import { render, staticRenderFns } from "./LanguageFormSettingView.vue?vue&type=template&id=fdb7d6ee&scoped=true&"
import script from "./LanguageFormSettingView.vue?vue&type=script&lang=js&"
export * from "./LanguageFormSettingView.vue?vue&type=script&lang=js&"
import style0 from "./LanguageFormSettingView.vue?vue&type=style&index=0&id=fdb7d6ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb7d6ee",
  null
  
)

export default component.exports